import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/ProgressSection.css";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { showProfileAlert } from "../utils/alerts";

export default function ProgressSection({ completed, total, datosUsuario, uid }) {
  const calificaciones = datosUsuario["19 Calificaciones"] || {};

  const percent = Math.round((completed / total) * 100);

  return (
    <section className="progress-section">
      <div className="progress-section-1">
        <div className="progress-section-header">
          <h5>Tu progreso</h5>
          <p><strong>{percent}%</strong></p>
        </div>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{ width: `${percent}%` }}
          ></div>
        </div>
        <p>✅{completed} temas aprobados de {total} </p>
      </div>
      <div className="progress-section-2">
        <button className="btn-edit" onClick={() => showProfileAlert(datosUsuario, uid)}>
          <FontAwesomeIcon icon={faPencil} />
          Editar perfil
        </button>
      </div>
    </section>
  );
}
